import { render, staticRenderFns } from "./WorkplaceForm.vue?vue&type=template&id=b1fe9bd2"
import script from "./WorkplaceForm.vue?vue&type=script&lang=js"
export * from "./WorkplaceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports